import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import prayerPartnerImg from "../../assests/amen.jpg";

function PrayerPartner() {
  const [submitting, setSubmitting] = useState(false);
  const [formData, setFormData] = useState({
    title: "",
    firstName: "",
    lastName: "",
    street: "",
    city: "",
    state: "",
    zip: "",
    email: "",
    phone: "",
    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);

    const payload = {
      _subject: `Prayer Request from ${formData.title} ${formData.firstName} ${formData.lastName}`.trim(),
      _captcha: "false",
      Title: formData.title,
      "First Name": formData.firstName,
      "Last Name": formData.lastName,
      Street: formData.street,
      City: formData.city,
      State: formData.state,
      "Zip Code": formData.zip,
      Email: formData.email,
      Phone: formData.phone,
      "Prayer Request": formData.message,
    };

    console.log("=== PRAYER REQUEST SUBMISSION START ===");
    console.log("PAYLOAD SENT:", payload);

    try {
      const response = await fetch("https://formsubmit.co/ajax/rajesh.teppala97@gmail.com", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(payload),
      });

      const result = await response.json();
      console.log("SERVER RESPONSE STATUS:", response.status);
      console.log("SERVER RESPONSE BODY:", result);
      console.log("=== PRAYER REQUEST SUBMISSION END ===");

      if (response.ok) {
        alert(`Mail status: ${result.message || "Prayer request sent successfully!"}\nCheck browser console for full payload & response details.`);
        setFormData({
          title: "",
          firstName: "",
          lastName: "",
          street: "",
          city: "",
          state: "",
          zip: "",
          email: "",
          phone: "",
          message: "",
        });
      } else {
        alert(`FormSubmit Error: ${result.message || "Failed to send"}\nCheck console for details.`);
      }
    } catch (error) {
      console.error("PRAYER REQUEST SUBMIT ERROR:", error);
      alert("Error sending prayer request: " + error.message);
    } finally {
      setSubmitting(false);
    }
  };

  const inputStyle = {
    width: "100%",
    padding: "10px 12px",
    border: "1px solid #cfcfcf",
    fontSize: "13px",
    outline: "none",
    boxSizing: "border-box",
    fontFamily: "Arial, sans-serif",
  };

  return (
    <div
      style={{
        fontFamily: "'Georgia','Times New Roman',serif",
        background: "#fff",
        color: "#333",
      }}
    >
      <div
        style={{
          maxWidth: "1100px",
          margin: "0 auto",
          padding: "0 1.5rem 3rem",
        }}
      >
        {/* Back */}
        <Link
          to="/"
          style={{
            color: "#c47a1e",
            textDecoration: "none",
            display: "inline-block",
            fontSize: "13px",
            marginTop: "1.5rem",
          }}
        >
          ← Back to Home
        </Link>

        {/* Heading */}
        <h1
          style={{
            fontFamily: "'Dancing Script','Brush Script MT',cursive",
            color: "#ef7d32",
            fontSize: "2.8rem",
            marginBottom: ".3rem",
          }}
        >
          Be a Prayer Partner
        </h1>

        {/* Orange Dots */}
        <div style={{ display: "flex", gap: 4, marginBottom: "2rem" }}>
          {[...Array(12)].map((_, i) => (
            <span
              key={i}
              style={{
                width: 5,
                height: 5,
                borderRadius: "50%",
                background: "#ef7d32",
              }}
            />
          ))}
        </div>

        {/* Top Section */}
        <div
          style={{
            display: "flex",
            gap: "2rem",
            flexWrap: "wrap",
            alignItems: "flex-start",
          }}
        >
          <img
            src={prayerPartnerImg}
            alt="Prayer Partner"
            style={{
              width: "430px",
              maxWidth: "100%",
              height: "300px",
              objectFit: "cover",
            }}
          />

          <div
            style={{
              flex: 1,
              minWidth: "300px",
              fontSize: "14px",
              lineHeight: "1.9",
            }}
          >
            <p>
              We need prayer covering for the work in India, and everyone can
              participate! Each month in our newsletter, we share prayer points
              about Christ For India and the Titus Family.
            </p>

            <p>
              We believe in the power of prayer. For over 41 years, our
              children and students pray each morning for our needs, and God
              answers those prayers. He is a faithful God!
            </p>

            <p>
              If you need specific prayer, we would be honored to pray for you,
              your family, business, or ministry. Every Friday night, we have
              fasting prayer on campus, and we pray for all our partners and
              the prayer requests we receive.
            </p>

            <p>
              Please email us your prayer request here.
            </p>
          </div>
        </div>

        {/* Prayer Request Form */}
        <div style={{ marginTop: "4rem" }}>
          <h2
            style={{
              fontSize: "22px",
              marginBottom: "2rem",
            }}
          >
            Prayer Request
          </h2>

          <form onSubmit={handleSubmit}>
            {/* Title */}
            <div
              style={{
                display: "flex",
                gap: "18px",
                flexWrap: "wrap",
                marginBottom: "1.5rem",
                fontSize: "13px",
              }}
            >
              {["Mr.", "Mrs.", "Ms.", "Dr.", "Rev."].map((title) => (
                <label key={title} style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                  <input
                    type="radio"
                    name="title"
                    value={title}
                    checked={formData.title === title}
                    onChange={handleChange}
                  />{" "}
                  {title}
                </label>
              ))}
            </div>

            {/* Form inputs */}
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit,minmax(280px,1fr))",
                gap: "1rem",
              }}
            >
              <input
                placeholder="First Name"
                name="firstName"
                value={formData.firstName}
                onChange={handleChange}
                style={inputStyle}
              />
              <input
                placeholder="Last Name"
                name="lastName"
                value={formData.lastName}
                onChange={handleChange}
                style={inputStyle}
              />

              <input
                placeholder="Street"
                name="street"
                value={formData.street}
                onChange={handleChange}
                style={inputStyle}
              />
              <input
                placeholder="City"
                name="city"
                value={formData.city}
                onChange={handleChange}
                style={inputStyle}
              />

              <input
                placeholder="State"
                name="state"
                value={formData.state}
                onChange={handleChange}
                style={inputStyle}
              />
              <input
                placeholder="Zip Code"
                name="zip"
                value={formData.zip}
                onChange={handleChange}
                style={inputStyle}
              />

              <input
                placeholder="Email"
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                style={inputStyle}
              />
              <input
                placeholder="Phone"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                style={inputStyle}
              />
            </div>

            <textarea
              placeholder="Prayer Request"
              name="message"
              rows={6}
              value={formData.message}
              onChange={handleChange}
              style={{
                ...inputStyle,
                width: "100%",
                marginTop: "1rem",
                resize: "vertical",
              }}
            />

            <button
              type="submit"
              disabled={submitting}
              style={{
                marginTop: "1.5rem",
                background: submitting ? "#aaa" : "#ef7d32",
                color: "#fff",
                border: "none",
                padding: "10px 28px",
                fontWeight: "bold",
                cursor: submitting ? "not-allowed" : "pointer",
                letterSpacing: "0.5px",
              }}
            >
              {submitting ? "SENDING..." : "SEND"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default PrayerPartner;
